var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character-profile"},[_c('profile-main-box',{attrs:{"profile":_vm.getCharacterProfile,"actionsList":_vm.actionsList},on:{"showCharacterUsersList":function($event){return _vm.$emit('showUsersList')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }